module.exports = __webpack_public_path__ + "resources/info-aadd7d933251e4f2663557032322e149.svg";